import { Section } from "../ui/Section";
import { Eyebrow } from "../ui/Eyebrow";
import { H2, Highlight } from "../ui/Heading";
import { CAPABILITIES } from "../data/capabilities";
import { CapabilityCard } from "./CapabilityCard";

export function WhatItDoes() {
  return (
    <Section id="what">
      <Eyebrow n="04">What it actually does</Eyebrow>
      <H2 className="max-w-[920px]">
        Eight things that <Highlight>save you an hour a day</Highlight>.
      </H2>
      <p className="mt-4.5 max-w-[640px] text-lg text-td-2">
        Each one runs inside Telegram. No new app to learn. No
        context-switching. Just chat with it like you would a teammate.
      </p>
      <div className="mt-16 grid grid-cols-4 gap-px bg-dash-d border border-dashed border-dash-d rounded-lg overflow-hidden max-md:grid-cols-2 max-[560px]:grid-cols-1">
        {CAPABILITIES.map((cap) => (
          <CapabilityCard key={cap.n} cap={cap} />
        ))}
      </div>
    </Section>
  );
}
